export class AdminApiError extends Error {
  constructor(public code: string, message: string) {
    super(message);
  }
}

const apiOrigin = (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/+$/, "") ?? "";

export async function adminApi<T>(path: string, init?: RequestInit): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`${apiOrigin}/api/admin${path}`, {
      ...init,
      credentials: "include",
      headers: { "content-type": "application/json", ...init?.headers }
    });
  } catch {
    throw new AdminApiError(
      "ADMIN_API_UNAVAILABLE",
      "管理服务暂时不可用，请稍后重试"
    );
  }
  const rawPayload = await response.text();
  let payload: {
    data?: T;
    error?: { code: string; message: string };
  } = {};
  if (rawPayload.trim()) {
    try {
      payload = JSON.parse(rawPayload) as typeof payload;
    } catch {
      throw new AdminApiError(
        "INVALID_ADMIN_API_RESPONSE",
        "管理服务返回异常，请刷新页面后重试"
      );
    }
  }
  if (!response.ok || payload.error) {
    throw new AdminApiError(
      payload.error?.code ?? "REQUEST_FAILED",
      payload.error?.message
        ?? (response.status >= 500
          ? "管理服务暂时不可用，请稍后重试"
          : "请求失败")
    );
  }
  if (!rawPayload.trim()) {
    throw new AdminApiError(
      "EMPTY_ADMIN_API_RESPONSE",
      "管理服务没有返回数据，请稍后重试"
    );
  }
  return payload.data as T;
}
